import { usePaginatedQuery } from "react-query-legacy";
import { WarehouseLoggedHoursType } from "services/BillingEngineService/interfaces/entities/WarehouseLoggedHours";
import { BillingEngineService } from "services";
import { hoursLoggedQueryKey } from "../constants";

function useQueryGetHours(type: WarehouseLoggedHoursType, page: number, pageSize: number, query: any) {
  return usePaginatedQuery([hoursLoggedQueryKey, type, page, pageSize, query], BillingEngineService.getWarehouseHours, {
    retry: false,
  });
}

export default useQueryGetHours;
